export class AvatarConstants {

    public static MAX_IMAGE_SIZE_IN_MB = (): number => 5; // 5 MB
    public static BYTES_IN_MB = (): number => 1024 * 1024; // 1 MB in bytes
    public static MIN_IMAGE_DIMENSIONS = (): number => 200; // 200px x 200px
    public static INITIALS_SIZE_FACTOR = (): number => 0.48; // Initials font size as a factor of avatar size

    public static SIZE = () => {
        return {
            USER_LIST: 50,
            MEMBER_LIST: 50,
            CHAT_MESSAGE: 20,
            TOP_MENU_PROFILE: 35,
            TOP_MENU_DROPDOWN_PROFILE: 50,
            PROFILE_PAGE: 100,
            MEMBER_CARD: 50,
            MEMBER_DETAIL: 50,
            THUMBNAIL: 20
        };
    };

    public static SHAPE = () => {
        return { 
            USER_LIST: "circle",
            MEMBER_LIST: "circle",
            CHAT_MESSAGE: "",
            TOP_MENU_PROFILE: "circle",
            PROFILE_PAGE: "circle",
            MEMBER_CARD: "circle",
            MEMBER_DETAIL: "",
            THUMBNAIL: ""
        };
    };

    public static ADDITIONAL_ATTRIBUTES = () => {
        return {
            USER_LIST: "overflow-hidden",
            MEMBER_LIST: "overflow-hidden",
            CHAT_MESSAGE: "",
            TOP_MENU_PROFILE: "overflow-hidden",
            PROFILE_PAGE: "overflow-hidden",
            MEMBER_CARD: "overflow-hidden",
            MEMBER_DETAIL: "",
            THUMBNAIL: ""
        };
    };
}
